module.exports = __webpack_public_path__ + "img/niceplanet.d24d3244.png";